import { Pattern } from '../types';
import humanInTheLoop from './patterns/human-in-the-loop-checkpoint.json';
import confidenceDisclosure from './patterns/confidence-disclosure.json';
import gracefulErrorRecovery from './patterns/graceful-error-recovery.json';
import progressiveOnboarding from './patterns/progressive-onboarding.json';
import conversationResetRecovery from './patterns/conversation-reset-recovery.json';
import expectationSettingForAiOutput from './patterns/expectation-setting-for-ai-output.json';
import gracefulAgentFailure from './patterns/graceful-agent-failure.json';
import clarificationWithoutInterrogation from './patterns/clarification-without-interrogation.json';
import decisionExplanationOnDemand from './patterns/decision-explanation-on-demand.json';
import undoAgentActions from './patterns/undo-agent-actions.json';
import permissionScoping from './patterns/permission-scoping.json';
import gracefulTopicBoundaries from './patterns/graceful-topic-boundaries.json';
import designingForSilenceVoiceUi from './patterns/designing-for-silence-voice-ui.json';
import noScreenOrientationVoice from './patterns/no-screen-orientation-voice.json';
import autonomousActionLog from './patterns/autonomous-action-log.json';
import agentScopeDefinition from './patterns/agent-scope-definition.json';
import sourceAttribution from './patterns/source-attribution.json';
import planPreviewAndLiveProgress from './patterns/plan-preview-and-live-progress.json';
import visibleAgentMemory from './patterns/visible-agent-memory.json';

export const patterns: Pattern[] = [
  humanInTheLoop,
  confidenceDisclosure,
  gracefulErrorRecovery,
  progressiveOnboarding,
  conversationResetRecovery,
  expectationSettingForAiOutput,
  gracefulAgentFailure,
  clarificationWithoutInterrogation,
  decisionExplanationOnDemand,
  undoAgentActions,
  permissionScoping,
  gracefulTopicBoundaries,
  designingForSilenceVoiceUi,
  noScreenOrientationVoice,
  autonomousActionLog,
  agentScopeDefinition,
  sourceAttribution,
  planPreviewAndLiveProgress,
  visibleAgentMemory,
] as Pattern[];

export const getPatternById = (id: string): Pattern | undefined =>
  patterns.find((p) => p.id === id);

export const getPatternsByCategory = (category: string): Pattern[] =>
  patterns.filter((p) => p.category === category);

export const getAllCategories = (): string[] =>
  patterns
    .map((p) => p.category)
    .filter((cat, index, arr) => arr.indexOf(cat) === index);
